import { Box, Heading, Image, Text, Grid } from '@grupoboticario/flora-react'
import { useTranslation } from 'react-i18next'
import useBreakpoint from '../../hooks/useBreakpoint'

const ReverseAddress = ({ reverseTrackingInfo }: { reverseTrackingInfo: Record<string, string> }) => {
  const data = reverseTrackingInfo
  const { isMobile } = useBreakpoint()
  const { t } = useTranslation()

  if (!data) return <div />

  return (
    <Box css={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row' }}>
      <Box css={{ width: isMobile ? '100%' : '50%' }}>
        <Heading as="h3" css={{ fontSize: '16px', lineHeight: '24px', fontWeight: 700, marginBottom: '8px' }}>
          {t('shippingCompany')}:
        </Heading>
        <Text className="text1 d-block">{reverseTrackingInfo.shippingCompanyName}</Text>
        <Image
          alt={reverseTrackingInfo.shippingCompanyName}
          src={reverseTrackingInfo.shippingCompanyImage}
          size={100}
        />

        <Heading as="h3" css={{ fontSize: '16px', lineHeight: '24px', fontWeight: 700, marginBottom: '8px' }}>
          {t('shippingMethod')}:
        </Heading>
        <Text>{t(`shippingMethodList.${reverseTrackingInfo.postType}`)}</Text>
      </Box>

      <Box css={{ width: isMobile ? '100%' : '50%', '& > div': { marginBottom: '$5' } }}>
        <Heading as="h3" css={{ fontSize: '$4', lineHeight: '$6', fontWeight: 700, marginBottom: '$3' }}>
          {t('from')}:
        </Heading>

        <Box>
          <Text className="text2 d-block">{t('sender')}</Text>
          <Text className="text1 d-block">{reverseTrackingInfo.sender}</Text>
        </Box>

        <Grid templateColumns="1fr 1fr" gap="$2">
          <Box>
            <Text className="text2 d-block">{t('cityState')}</Text>
            <Text className="text1 d-block">{`${reverseTrackingInfo.senderCity} - ${reverseTrackingInfo.senderState}`}</Text>
          </Box>
          <Box>
            <Text className="text2 d-block">{t('destinyZipCode')}</Text>
            <Text className="text1 d-block">{maskZipcode(reverseTrackingInfo.senderPostalCode)}</Text>
          </Box>
        </Grid>

        <Heading as="h3" css={{ fontSize: '$4', lineHeight: '$6', fontWeight: 700, margin: '$5 0 $3' }}>
          {t('to')}:
        </Heading>

        <Box>
          <Text className="text2 d-block">{t('recipient')}</Text>
          <Text className="text1 d-block">{reverseTrackingInfo.recipient}</Text>
        </Box>

        <Grid templateColumns="1fr 1fr" gap="$2">
          <Box>
            <Text className="text2 d-block">{t('address')}:</Text>
            <Text className="text1 d-block">{reverseTrackingInfo.recipientAddress}</Text>
          </Box>
          <Box>
            <Text className="text2 d-block">{t('district')}:</Text>
            <Text className="text1 d-block">{reverseTrackingInfo.recipientDistric}</Text>
          </Box>
        </Grid>

        <Grid templateColumns="1fr 1fr" gap="$2">
          <Box>
            <Text className="text2 d-block">{t('cityState')}</Text>
            <Text className="text1 d-block">
              {`${reverseTrackingInfo.recipientCity} - ${reverseTrackingInfo.recipientState}`}
            </Text>
          </Box>
          <Box className="fundo-azul">
            <Text className="text2 d-block">{t('originZipCode')}</Text>
            <Text className="text1 d-block">{maskZipcode(reverseTrackingInfo.recipientPostalCode)}</Text>
          </Box>
        </Grid>
      </Box>
    </Box>
  )
}

export default ReverseAddress

const maskZipcode = (zip: string) => {
  const reg = /(\d{5})(\d{3})/g
  const rep = zip.replace(reg, '$1-$2')

  return rep
}
